// LUMINA · pages/VajraPublicCalendar.jsx
// Phase 40 F5: 公开法讯日历 — /vajra/calendar （无需登录）

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicEventCalendar from './vajra/components/PublicEventCalendar';
import EventDetailModal from './vajra/components/EventDetailModal';

import { API, GD, GDL, BG, TXT, TXT2, PANEL } from "./vajra/constants";
const DG     = "#064E3B";

const RECURRENCE_LABELS = {
  weekly_sat:"每周六", weekly_sun:"每周日", weekly_fri:"每周五",
  weekly:"每周", biweekly:"每两周", monthly:"每月", custom:"不定期",
};

const EVENT_TYPE_LABEL = {
  teaching:"教法", empowerment:"灌顶", puja:"法会", retreat:"闭关",
  ritual:"法事", weekly_practice:"共修", other:"其他",
};
const EVENT_TYPE_COLOR = {
  teaching:"#3b82f6", empowerment:"#dc2626", puja:"#d97706",
  retreat:"#8b5cf6", ritual:"#10b981", weekly_practice:DG, other:"#6b7280",
};

export default function VajraPublicCalendar({ lang }) {
  const navigate = useNavigate();
  const [events,        setEvents]        = useState([]);
  const [schedules,     setSchedules]     = useState([]);
  const [view,          setView]          = useState("list");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [calMonth,      setCalMonth]      = useState(new Date());

  useEffect(() => {
    document.title = "金刚社群 · 法讯日历 | BTF Canada";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.content = "显密文教基金会法会活动、上师开示、灌顶传承日历。欢迎十方善信参与共修。";
  }, []);

  useEffect(() => {
    fetch(`${API}/vajra/events/public`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setEvents(Array.isArray(d) ? d : []))
      .catch(() => {});
    fetch(`${API}/vajra/schedules`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setSchedules(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  // Merge schedules with next_date into calendar items (so 共修 shows on calendar)
  const scheduleCalendarItems = schedules
    .filter(s => s.is_active && s.next_date)
    .map(s => ({
      id: `sched-${s.id}`,
      title_zh: s.title_zh,
      title_en: s.title_en,
      start_date: s.next_date,
      start_time: s.time_start,
      end_time: s.time_end,
      timezone: s.timezone,
      location: s.location,
      online_link: s.online_link,
      description: s.description,
      teacher_zh: s.teacher_zh,
      event_type: 'weekly_practice',
      _isSchedule: true,
    }));
  const allCalendarItems = [...events, ...scheduleCalendarItems];

  const PORTAL_TABS = [
    { key:"home",      label:"首页" },
    { key:"practice",  label:"修行" },
    { key:"events",    label:"法讯" },
    { key:"teachers",  label:"传承上师" },
    { key:"service",   label:"服务" },
    { key:"teachings", label:"法教" },
    { key:"subscribe", label:"订阅法讯" },
  ];

  const btnStyle = (v) => ({
    padding: "5px 16px", borderRadius: 20, fontSize: 12, cursor: "pointer",
    border: `1px solid ${view === v ? DG : "rgba(6,78,59,0.2)"}`,
    background: view === v ? "rgba(6,78,59,0.08)" : "transparent",
    color: view === v ? DG : "#aaa",
  });

  return (
    <div style={{ minHeight:"100vh", background:BG, fontFamily:"'Noto Serif SC', 'Inter', sans-serif" }}>

      {/* Top nav — Vajra Portal bar */}
      <div style={{
        background:"rgba(253,251,247,0.97)",padding:"12px 28px 0",
        borderBottom:"1px solid rgba(212,175,55,0.28)",
        boxShadow:"0 2px 12px rgba(139,105,20,0.07)",
        backdropFilter:"blur(16px)",position:"sticky",top:0,zIndex:100}}>
        <div style={{maxWidth:1100,margin:"0 auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
            <div onClick={()=>navigate("/vajra")} style={{cursor:"pointer"}}>
              <div style={{color:GD,fontSize:18,letterSpacing:3,fontFamily:"'Noto Serif SC','Noto Serif',serif"}}>如意宝金刚社群</div>
              <div style={{color:TXT2,fontSize:10,letterSpacing:1,opacity:0.7}}>BTF CANADA</div>
            </div>
            <div style={{color:TXT2,fontSize:12}}>法讯日历</div>
          </div>
          <div style={{display:"flex",gap:0,overflowX:"auto"}}>
            {PORTAL_TABS.map(t=>(
              <button key={t.key} onClick={()=>navigate(`/vajra/${t.key==="home"?"":t.key}`)}
                style={{padding:"8px 16px",background:"none",border:"none",cursor:"pointer",
                  fontSize:12,letterSpacing:.6,
                  color:TXT2,
                  opacity:0.75,
                  borderBottom:"2px solid transparent",
                  marginBottom:-1,transition:"color .2s",
                  whiteSpace:"nowrap"}}>
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth:900, margin:"0 auto", padding:"20px 24px 60px" }}>

        {/* 视图切换 */}
        <div style={{ display:"flex", gap:8, marginBottom:20 }}>
          {[["list","活动列表"],["calendar","日历视图"],["recurring","定期共修"]].map(([v, label]) => (
            <button key={v} onClick={() => setView(v)} style={btnStyle(v)}>{label}</button>
          ))}
        </div>

        {/* 活动列表 */}
        {view === "list" && (
          <>
            {events.length === 0 ? (
              <div style={{ textAlign:"center", padding:"60px 0", color:"#bbb", fontSize:13 }}>
                近期暂无公开法讯，敬请期待
              </div>
            ) : (
              events.map(ev => {
                const typeColor = EVENT_TYPE_COLOR[ev.event_type] || GD;
                const typeLabel = EVENT_TYPE_LABEL[ev.event_type] || ev.event_type || "活动";
                return (
                  <div key={ev.id} onClick={() => setSelectedEvent(ev)} style={{ background:PANEL, borderRadius:12, padding:"18px 20px", marginBottom:12, border:"1px solid rgba(212,175,55,0.18)", cursor:"pointer", transition:"box-shadow .2s", boxShadow:"0 1px 4px rgba(0,0,0,0.04)" }}
                    onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.09)"}
                    onMouseLeave={e=>e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.04)"}>
                    <div style={{ display:"flex", gap:6, marginBottom:8, flexWrap:"wrap" }}>
                      <span style={{ fontSize:10, color:typeColor, background:`${typeColor}10`, border:`1px solid ${typeColor}33`, borderRadius:10, padding:"1px 8px" }}>
                        {typeLabel}
                      </span>
                      {ev.donation_type === "free" && (
                        <span style={{ fontSize:10, color:"#059669", background:"rgba(5,150,105,0.08)", border:"1px solid rgba(5,150,105,0.2)", borderRadius:10, padding:"1px 8px" }}>免费</span>
                      )}
                      {ev.donation_type === "donation" && (
                        <span style={{ fontSize:10, color:"#d97706", background:"rgba(217,119,6,0.08)", border:"1px solid rgba(217,119,6,0.2)", borderRadius:10, padding:"1px 8px" }}>随喜</span>
                      )}
                      {ev.donation_type === "fixed" && ev.fee_amount && (
                        <span style={{ fontSize:10, color:"#dc2626", background:"rgba(220,38,38,0.06)", border:"1px solid rgba(220,38,38,0.18)", borderRadius:10, padding:"1px 8px" }}>
                          ${(ev.fee_amount/100).toFixed(0)} CAD
                        </span>
                      )}
                    </div>
                    <div style={{ fontSize:16, color:TXT, fontWeight:600, marginBottom:6 }}>{lang === 'en' && ev.title_en ? ev.title_en : ev.title_zh}</div>
                    {ev.start_date && (
                      <div style={{ fontSize:12, color:TXT2 }}>
                        📅 {ev.start_date}{ev.end_date && ev.end_date !== ev.start_date ? ` — ${ev.end_date}` : ""}
                        {ev.start_time && <span> · ⏰ {ev.start_time}</span>}
                      </div>
                    )}
                    {ev.teacher_zh && <div style={{ fontSize:12, color:TXT2, marginTop:2 }}>🪷 {ev.teacher_zh}</div>}
                    {ev.location   && <div style={{ fontSize:12, color:TXT2, marginTop:2 }}>📍 {ev.location}</div>}
                  </div>
                );
              })
            )}
          </>
        )}

        {/* 日历视图 */}
        {view === "calendar" && (
          <PublicEventCalendar
            events={allCalendarItems}
            calMonth={calMonth}
            setCalMonth={setCalMonth}
            setSelectedEvent={(item) => {
              if (item?._isSchedule) return; // schedules have no detail modal
              setSelectedEvent(item);
            }}
          />
        )}

        {/* 定期共修 */}
        {view === "recurring" && (
          <div>
            {schedules.length === 0 ? (
              <div style={{ textAlign:"center", padding:"60px 0", color:"#bbb", fontSize:13 }}>
                暂无定期共修安排
              </div>
            ) : (
              schedules.map(sc => (
                <div key={sc.id} style={{ background:PANEL, borderRadius:12, padding:"18px 20px", marginBottom:14, border:"1px solid rgba(212,175,55,0.2)" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                    <div>
                      <div style={{ fontSize:15, color:TXT, fontWeight:600 }}>{lang === 'en' && sc.title_en ? sc.title_en : sc.title_zh}</div>
                      {sc.teacher_zh && <div style={{ fontSize:12, color:TXT2, marginTop:2 }}>🪷 {sc.teacher_zh}</div>}
                    </div>
                    <span style={{ fontSize:10, color:DG, background:"rgba(6,78,59,0.08)", border:"1px solid rgba(6,78,59,0.2)", borderRadius:10, padding:"2px 10px", flexShrink:0, marginLeft:8 }}>
                      {RECURRENCE_LABELS[sc.recurrence] || sc.recurrence}
                    </span>
                  </div>
                  <div style={{ marginTop:10, fontSize:12, color:TXT2, lineHeight:1.8 }}>
                    {sc.next_date && <div>📅 下次：{sc.next_date}</div>}
                    {sc.time_start && (
                      <div>⏰ {sc.time_start}{sc.time_end ? `–${sc.time_end}` : ""} {sc.timezone}</div>
                    )}
                    {sc.location    && <div>📍 {sc.location}</div>}
                    {sc.online_link && (
                      <div>💻 <a href={sc.online_link} target="_blank" rel="noopener noreferrer" style={{ color:DG }}>线上链接</a></div>
                    )}
                  </div>
                  {sc.description && (
                    <div style={{ marginTop:8, fontSize:12, color:TXT2, lineHeight:1.7 }}>{sc.description}</div>
                  )}
                </div>
              ))
            )}
          </div>
        )}
      </div>

      {/* EventDetailModal — isLoggedIn=false redirects 报名 to /vajra */}
      {selectedEvent && (
        <EventDetailModal
          event={selectedEvent}
          onClose={() => setSelectedEvent(null)}
          lang={lang || "zh"}
          isLoggedIn={false}
          onRegister={() => window.location.href = "/vajra"}
        />
      )}

      {/* Footer */}
      <div style={{ textAlign:"center", padding:"32px 0 20px", fontSize:11, color:"#aaa", borderTop:"1px solid rgba(0,0,0,0.06)", marginTop:20 }}>
        © 2026 显密文教基金会 · BTF Canada · Toronto<br/>
        联系：canada.btf@gmail.com
      </div>
    </div>
  );
}
